import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const EmailVerified = () => {
  const navigate = useNavigate();
  const { user, profile, loading } = useAuth();

  useEffect(() => {
    // Auto-redirect after 3 seconds if user is authenticated
    if (!loading && user) {
      const timer = setTimeout(() => {
        // Check if onboarding completed
        if (!profile?.onboarding_completed || !profile?.industry) {
          navigate('/app/industry-selection');
        } else {
          navigate('/app/dashboard');
        }
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [user, profile, loading, navigate]);

  const handleContinue = () => {
    if (!loading && user) {
      if (!profile?.onboarding_completed || !profile?.industry) {
        navigate('/app/industry-selection');
      } else {
        navigate('/app/dashboard');
      }
    } else {
      navigate('/authentication');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-accent/5 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-card rounded-2xl shadow-xl p-8 border border-border text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="CheckCircle" size={48} color="var(--color-success)" />
          </div>

          {/* Success Message */}
          <h1 className="text-3xl font-bold text-foreground mb-3">
            Email Verified!
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8">
            Your email has been successfully verified. You're all set to start your sales training journey.
          </p>

          {/* Action Button */}
          <Button
            size="lg"
            className="w-full mb-4"
            onClick={handleContinue}
            iconName="ArrowRight"
            iconPosition="right"
          >
            Continue to Platform
          </Button>

          {/* Auto-redirect notice */}
          <p className="text-sm text-muted-foreground">
            Redirecting automatically in 3 seconds...
          </p>
        </div>

        {/* Additional Info */}
        <div className="mt-6 text-center">
          <p className="text-sm text-muted-foreground">
            Need help? <a href="mailto:support@earnmyedge.com" className="text-primary hover:underline">Contact Support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerified;
